import { render, staticRenderFns } from "./QQuestionTooltip.vue?vue&type=template&id=0716079d&scoped=true&"
var script = {}
import style0 from "./QQuestionTooltip.vue?vue&type=style&index=0&id=0716079d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0716079d",
  null
  
)

export default component.exports